import { DialogActions, IconButton, InputAdornment } from "@material-ui/core";
import { People, Cancel, Search } from "@mui/icons-material";
import { useFormikContext } from "formik";
import React from "react";
import { useState } from "react";
import store from "../../../../../../store/store";
import { Card, Badge } from "react-bootstrap";
import {
  CustomTextAreaField,
  CustomTextField,
} from "../../../../../../partials/content/Forms";
import {
  FormDateField,
  FormTextField,
} from "../../../../../../partials/content/Forms/FormField";
import DialogLayout from "../../../../../../partials/content/DialogLayout";
import SearchUser from "../../../../users/users/searchUser";
import BootstrapTooltip from "../../../../../../partials/content/BootstrapTooltip";

function JourneyEditFormContent(props) {
  const {
    handleBlur,
    handleChange,
    values,
    touched,
    errors,
    setFieldValue,
  } = useFormikContext();
  const [openSearchUser, setOpenSearchUser] = useState(false);
  const { auth } = store.getState();
  const { userID, fullName } = auth.user;
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-window-maximize"></i>
              <span>
                <strong>Sales Journey Header</strong>
              </span>
              {values.ID > 0 ? (
                <React.Fragment>
                  <Badge
                    className="float-right ml-1"
                    variant={
                      values.statusID === 1
                        ? "warning"
                        : values.statusID === 2
                        ? "primary"
                        : values.statusID === 3
                        ? "success"
                        : values.statusID === 9
                        ? "danger"
                        : null
                    }
                  >
                    {values.statusID !== 0
                      ? "Journey " + values.statusDesc
                      : null}
                  </Badge>
                </React.Fragment>
              ) : null}
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormTextField label="Sales Journey Name" name="title" />
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormDateField
                        name="planStartDate"
                        label="Plan Start Date"
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormDateField
                        name="planEndDate"
                        label="End Start Date"
                      />
                    </div>
                  </div>
                  <FormTextField
                    label="Assigned To"
                    name="salesName"
                    assignmeButton
                    searchButton
                    clearButton
                    onAssignmeClick={() => {
                      setFieldValue("salesID", userID);
                      setFieldValue("salesName", fullName);
                    }}
                    onSearchClick={() => {
                      setOpenSearchUser(true);
                    }}
                    onClearFields={() => {
                      setFieldValue(`salesID`, 0);
                      setFieldValue(`salesName`, "");
                    }}
                    readonly
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormTextField
                    label="Description"
                    name="description"
                    multiline
                    minRows={7}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <DialogLayout
        open={openSearchUser}
        title="Search User"
        onCloseDialog={() => {
          setOpenSearchUser(false);
        }}
        maxWIdth="lg"
      >
        <SearchUser
          salesUser="true"
          onSelectUser={(user) => {
            setFieldValue(`salesID`, user.ID);
            setFieldValue(`salesName`, user.firstName + " " + user.lastName);
            setOpenSearchUser(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchUser(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default JourneyEditFormContent;
